import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import { Button, Stack } from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import Multiselect from '../EventModal/components/Multiselect'

const CreateModal = ({ appData, handleRefresh }) => {
  const uploadImage = useUploadImage()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [selectedImages, setSelectedImages] = useState([]) // State to store selected images
  const AppService = useAppServices()

  const handlemodal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }

  useEffect(() => { }, [])

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleImageChange = (e) => {
      const files = Array.from(e.target.files)
      const filePreviews = files.map((file) => ({
        file,
        preview: URL.createObjectURL(file), // Create preview URLs for images
      }))
      setSelectedImages(filePreviews)
    }

    const handleSubmit = async (e) => {
      e.preventDefault()
      let images = appData.images
      if (selectedImages.length) {
        setProcessing(true)
        for (let index = 0; index < selectedImages.length; index++) {
          const element = selectedImages[index].file
          const imgType = JSON.parse(e.target.imgType.value)

          const image_response = await uploadImage({
            file: element,
            desiredPath: `app/logo/image`,
          })
          const imagedata = {
            image: image_response.response.data,
            type: imgType,
          }
          const payload = {
            _id: appData._id,
            images: [...images, imagedata],
          }

          const { response } = await AppService.app.update({
            payload: payload,
          })
          if (response) {
            images.push(imagedata)
          }
        }
        setProcessing(false)
        onClose()
        handleRefresh()
        setSelectedImages([]) // Clear selected images after submission
      } else {
        alert('Please select at least one image')
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: 'auto',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }

    const typeOptions = [
      { label: 'Agency', value: 'agency' },
      { label: 'Sub Account', value: 'sub-account' },
      { label: 'Both', value: 'both' },
    ]

    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              App Images
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Image Type
              </MDTypography>
              <Multiselect data={typeOptions} isMulti={false} name="imgType" />
            </MDBox>
            <MDBox mt={2} mb={2} ml={1} display="flex" alignItems="center">
              <Stack direction="row" alignItems="center" spacing={2}>
                <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                  Upload Images +
                  <input
                    hidden
                    name="image"
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                  />
                </Button>
              </Stack>
            </MDBox>

            {/* Preview Selected Images */}
            <MDBox mt={2}>
              {selectedImages.map((img, index) => (
                <img
                  key={index}
                  src={img.preview}
                  alt={`preview-${index}`}
                  style={{ width: '100px', height: '100px', margin: '5px', objectFit: 'cover' }}
                />
              ))}
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Upload Image
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
